// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cYIh","newExpiryDate":"styles_newExpiryDate__3pPKA","footer":"styles_footer__1ieRV"};